import React from "react";
import "./IotmateButton.css";

const IotmateButton = ({
  onClick,
  children,
  variant = "default",
  size = "medium",
  className = "",
  disabled = false,
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`iotmate-btn iotmate-btn-${variant} iotmate-btn-${size} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default IotmateButton;